import React from "react";
import Select from "react-select/creatable";
import Modal from "../../Shared/PopupModal/PopupModal";
import UpgradeModal from "../../UpgradeModal/UpgradeModal";
import RequestApproval from "./Approval/RequestApproval";
import PendingApproval from "./Approval/PendingApproval";
import Auctions from "../Auctions/Auctions";
import { DownloadReports } from "./DownloadReport/DeliveryReport";
import MyLsp from "./MyLsp";
import { isMobile, Activity, currentRequestTimeStamp, spotFilterOptions } from "../../../Constants";
import classes from "../TrucksAvailable.module.css";
import toolbarStyles from "./EnquiryToolbar.module.css";

const desktopSelectStyles = {
  control: (base, state) => ({
    ...base,
    fontSize: "12px",
    fontWeight: "600",
    minHeight: "28px",
    height: "28px",
    borderRadius: "6px",
    border: `1px solid ${state.isFocused ? "#393185" : "#393185"}`,
    boxShadow: "none",
    backgroundColor: "#F5F4FB",
    textAlign: "left",
    cursor: "pointer",
    "&:hover": {
      borderColor: "#393185",
      backgroundColor: "#EDEBFA",
    },
  }),
  valueContainer: (base) => ({
    ...base,
    padding: "0 10px",
    height: "26px",
  }),
  indicatorsContainer: (base) => ({
    ...base,
    height: "26px",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: "0 8px",
    color: "#393185",
    "&:hover": { color: "#393185" },
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  singleValue: (base) => ({
    ...base,
    color: "#393185",
    fontWeight: "700",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  }),
  container: (base) => ({
    ...base,
    width: "100%",
  }),
  menu: (base) => ({
    ...base,
    borderRadius: "6px",
    overflow: "hidden",
    border: "1px solid #E4E7EC",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
    marginTop: "4px",
  }),
  menuList: (base) => ({
    ...base,
    padding: "4px",
  }),
  option: (base, state) => ({
    ...base,
    fontSize: "12.5px",
    fontWeight: state.isSelected ? "700" : "500",
    borderRadius: "6px",
    padding: "8px 10px",
    cursor: "pointer",
    backgroundColor: state.isSelected
      ? "#393185"
      : state.isFocused
        ? "#F5F4FB"
        : "#ffffff",
    color: state.isSelected ? "#ffffff" : "#333333",
    "&:active": {
      backgroundColor: state.isSelected ? "#393185" : "#EDEBFA",
    },
  }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
};

const EnquiryToolbar = ({
  isdownload,
  interval_days,
  enquiryBucket,
  enquiryLevel,
  canAccessReports,
  auctionAllowed,
  isAuction,
  allowed_auction,
  requestapprovallist,
  company_name,
  isRestricted,
  showapprovingloader,
  isApprover,
  approver_list,

  autoPushIndent,
  setsend_data,
  enquiryTransition,
  setmastertransporterlist,
  planningbutton,
  history,
  apply_Filter,
  setFilters_applied,
  setselected_user,
  setselected_truck_type,
  setselected_origin_name,
  setselected_destination_name,
  setselected_placement_date,
  setselected_contract,
  setRequestapprovallist,
  setEnquiryBucket,
  TrackMixPanel,
  visible_enquiry,
  expiredEnquiries,
  cancelEnquiry,
  approveEnquiry,
  iscompanycheck,
  userview,
  setuserview,
  setEnquiryLevel,
  closeModal1,
  cancelApprovalPending,
  children,
  backbutton,
  discovernowbutton,
  setFilter,
  handleOutsideFilterChange,
  companySettingData
}) => {
  const bucketOptions = [
    { value: "all", label: "All Enquiry" },
    { value: "active", label: "Active Enquiry" },
    { value: "cancelled", label: "Cancelled Enquiry" },
    { value: "archived", label: "Archived Enquiry" },
    { value: "approved", label: "Approved Enquiry" },
    ...(companySettingData?.enquiry?.post_expiry_acceptance === true
      ? isApprover
        ? [{ value: "pending_approval", label: "Expired Pending Approval" }]
        : [{ value: "pending_acceptance", label: "Expired Pending Acceptance" }]
      : []),
  ];

  if (isMobile()) {
    return (
      <div
        className="row"
        style={{
          margin: "0% 0% 0% 2%",
          justifyContent: "center",
          width: "100%",
          marginLeft: 0,
          marginRight: 0,
        }}
      >
        <div
          className={classes["mobileScrollRow"]}
          style={{
            display: "flex",
            flexWrap: "nowrap",
            overflowX: "auto",
            WebkitOverflowScrolling: "touch",
            padding: "8px 15px",
            margin: "0",
            minWidth: 0,
            maxWidth: "100%",
            alignItems: "center",
          }}
        >
          <button
            className="btn btn-sm btn-primary tr-button1"
            style={{
              margin: "0 0%",
              fontSize: "13px",
              height: "33px",
              padding: "0 10px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
            onClick={() => setFilter(true)}
            title="Filter"
          >
            <i className="fa fa-filter" />
          </button>

          {!backbutton && !discovernowbutton && !planningbutton && (
            <>
              <div style={{ margin: "0 5% 0 0%", flexShrink: 0 }}>
                {isdownload && (
                  <Modal
                    buttonLabel={<>Download Report</>}
                    buttonClass="btn btn-sm btn-primary tr-button1"
                    content={
                      <DownloadReports
                        days={interval_days}
                        bucket={enquiryBucket}
                        level={enquiryLevel}
                        screen={"spot"}
                      />
                    }
                    title={<b>Report Generator</b>}
                    id="closebutton"
                    size={"lg"}
                    screenName="LoRRI Spot"
                    moduleName="My Enquiries"
                    activityName={`Download Report`}
                    backdrop={false}
                    style={{
                      fontSize: "13px",
                      margin: "2% -5%",
                      cursor: canAccessReports ? "pointer" : "not-allowed",
                      opacity: canAccessReports ? 1 : 0.6,
                    }}
                    disabled={canAccessReports ? false : true}
                  />
                )}
              </div>

              <div style={{ margin: "0 5% 0 0%", flexShrink: 0 }}>
                {auctionAllowed === "yes" &&
                  isAuction &&
                  allowed_auction > 0 ? (
                  <Modal
                    buttonLabel={`Create Auctions`}
                    buttonClass="btn btn-sm btn-primary"
                    content={
                      <Auctions
                        auctionlist={requestapprovallist}
                        company_name={company_name}
                      />
                    }
                    title={`Create Auctions`}
                    id="closebutton"
                    screenName="LoRRI Spot"
                    moduleName="My Enquiries"
                    activityName={`Request Approval Button Clicked`}
                    dialogClassName={classes.pendingmodal}
                    backdrop={false}
                    onClose={closeModal1}
                    style={{
                      fontSize: "13px",
                      cursor: isRestricted ? "not-allowed" : "pointer",
                      opacity: isRestricted ? 0.6 : 1,
                    }}
                    disabled={isRestricted}
                  />
                ) : (
                  <UpgradeModal
                    screenName="LoRRI Spot"
                    moduleName="Upgrade Popup"
                    activityName="Create auction button clicked"
                    buttonClass="btn btn-sm btn-primary"
                    buttonLabel="Create Auctions"
                    feature="Create Auctions"
                    style={{
                      cursor: isRestricted ? "not-allowed" : "pointer",
                      opacity: isRestricted ? 0.6 : 1,
                    }}
                    disabled={isRestricted}
                  />
                )}
              </div>

              {!showapprovingloader &&
                (!isApprover ? (
                  <div style={{ margin: "0 1%", flexShrink: 0 }}>
                    <Modal
                      buttonLabel={`Request Approval`}
                      buttonClass="btn btn-sm btn-primary"
                      content={
                        <RequestApproval
                          requestapprovallist={requestapprovallist}
                          approverList={approver_list}
                        />
                      }
                      title={`Request Approval`}
                      subtitle="Note: Only enquiries which are Accepted and Not Approved can be sent for approval"
                      id="closebutton"
                      size={"lg"}
                      screenName="LoRRI Spot"
                      moduleName="My Enquiries"
                      activityName={`Request Approval Button Clicked`}
                      dialogClassName={classes.pendingmodal}
                      backdrop={false}
                      style={{
                        fontSize: "13px",
                        margin: "",
                        cursor: isRestricted ? "not-allowed" : "pointer",
                        opacity: isRestricted ? 0.6 : 1,
                      }}
                      disabled={isRestricted}
                    />
                  </div>
                ) : (
                  <div style={{ margin: "0 1%", flexShrink: 0 }}>
                    <Modal
                      buttonLabel={
                        isMobile()
                          ? "Pending Approvals"
                          : "Click Here to check Pending Approvals"
                      }
                      buttonClass="btn btn-sm btn-primary"
                      content={
                        <PendingApproval
                          autoPushIndent={autoPushIndent}
                          setsend_data={setsend_data}
                          enquiryTransition={enquiryTransition}
                        />
                      }
                      title={`Enquiry Pending for Approval`}
                      id="pendingApprovalCloseButton"
                      size={"md"}
                      screenName="LoRRI Spot"
                      moduleName="My Enquiries"
                      activityName={`Request Approval Button Clicked`}
                      backdrop={false}
                      dialogClassName={classes.pendingmodal}
                      style={{
                        fontSize: "13px",
                        cursor: isRestricted ? "not-allowed" : "pointer",
                        opacity: isRestricted ? 0.6 : 1,
                      }}
                      onClose={cancelApprovalPending}
                      disabled={isRestricted}
                    />
                  </div>
                ))}
            </>
          )}

          <div style={{ flexShrink: 0, margin: "0 1%" }}>
            <Modal
              buttonLabel={`Add Recommended Transporters`}
              disabled={isRestricted}
              buttonClass={`btn btn-sm btn-primary ${classes["shortlist-button"]} `}
              content={
                <MyLsp
                  setmastertransporterlist={setmastertransporterlist}
                  planningbutton={planningbutton}
                />
              }
              title={`Add Recommended Transporters`}
              id="closebutton"
              screenName="LoRRI Spot"
              moduleName="My Enquiries"
              activityName={`Add Transporter Button clicked`}
              backdrop={false}
              size={isMobile() ? "sm" : "md"}
              style={{
                fontSize: "13px",
                height: "33px",
                cursor: isRestricted ? "not-allowed" : "pointer",
                opacity: isRestricted ? 0.6 : 1,
              }}
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={toolbarStyles.toolbarCard}>
      {/* Left Action Buttons */}
      <div className={toolbarStyles.leftSection}>
        <button
          className={toolbarStyles.filterBtn}
          onClick={() => setFilter(true)}
          title="Filter"
        >
          <i className="fa fa-filter" />
        </button>

        {!backbutton && !discovernowbutton && !planningbutton && (
          <>
            {isdownload && (
              <Modal
                buttonLabel="Download Report"
                buttonClass={toolbarStyles.ghostBtn}
                content={
                  <DownloadReports
                    days={interval_days}
                    bucket={enquiryBucket}
                    level={enquiryLevel}
                    screen={"spot"}
                  />
                }
                title={<b>Report Generator</b>}
                id="closebutton"
                size={"lg"}
                screenName="LoRRI Spot"
                moduleName="My Enquiries"
                activityName={`Download Report`}
                backdrop={false}
                style={{
                  cursor: canAccessReports ? "pointer" : "not-allowed",
                  opacity: canAccessReports ? 1 : 0.6,
                }}
                disabled={canAccessReports ? false : true}
              />
            )}

            {auctionAllowed === "yes" &&
              isAuction &&
              allowed_auction > 0 ? (
              <Modal
                  buttonLabel="Create Auctions"
                  buttonClass={toolbarStyles.ghostBtn}
                  content={
                    <Auctions
                      auctionlist={requestapprovallist}
                      company_name={company_name}
                    />
                  }
                  title="Create Auctions"
                  id="closebutton"
                  screenName="LoRRI Spot"
                  moduleName="My Enquiries"
                  activityName={`Request Approval Button Clicked`}
                  dialogClassName={classes.pendingmodal}
                  backdrop={false}
                  onClose={closeModal1}
                  style={{
                  cursor: isRestricted ? "not-allowed" : "pointer",
                  opacity: isRestricted ? 0.6 : 1,
                }}
                disabled={isRestricted}
              />
            ) : (
              <UpgradeModal
                screenName="LoRRI Spot"
                moduleName="Upgrade Popup"
                activityName="Create auction button clicked"
                buttonClass={toolbarStyles.ghostBtn}
                buttonLabel="Create Auctions"
                feature="Create Auctions"
                style={{
                  cursor: isRestricted ? "not-allowed" : "pointer",
                  opacity: isRestricted ? 0.6 : 1,
                }}
                disabled={isRestricted}
              />
            )}

            {!showapprovingloader &&
              (!isApprover ? (
              <Modal
                buttonLabel="Request Approval"
                buttonClass={toolbarStyles.ghostBtn}
                content={
                  <RequestApproval
                    requestapprovallist={requestapprovallist}
                    approverList={approver_list}
                  />
                }
                title="Request Approval"
                subtitle="Note: Only enquiries which are Accepted and Not Approved can be sent for approval"
                id="closebutton"
                size={"lg"}
                screenName="LoRRI Spot"
                moduleName="My Enquiries"
                activityName={`Request Approval Button Clicked`}
                dialogClassName={classes.pendingmodal}
                backdrop={false}
                style={{
                  cursor: isRestricted ? "not-allowed" : "pointer",
                  opacity: isRestricted ? 0.6 : 1,
                }}
                disabled={isRestricted}
              />
            ) : (
                <Modal
                  buttonLabel="Pending Approvals"
                  buttonClass={toolbarStyles.ghostBtn}
                  content={
                    <PendingApproval
                      autoPushIndent={autoPushIndent}
                      setsend_data={setsend_data}
                      enquiryTransition={enquiryTransition}
                    />
                  }
                  title="Enquiry Pending for Approval"
                  id="pendingApprovalCloseButton"
                  size={"md"}
                  screenName="LoRRI Spot"
                  moduleName="My Enquiries"
                  activityName={`Request Approval Button Clicked`}
                  backdrop={false}
                  dialogClassName={classes.pendingmodal}
                  style={{
                    cursor: isRestricted ? "not-allowed" : "pointer",
                    opacity: isRestricted ? 0.6 : 1,
                  }}
                  onClose={cancelApprovalPending}
                  disabled={isRestricted}
                />
              ))}
          </>
        )}
      </div>

      {/* Right Action Filters */}
      <div className={toolbarStyles.rightSection}>
        <Modal
          buttonLabel="Add Recommended Transporters"
          disabled={isRestricted}
          buttonClass={toolbarStyles.ghostBtn}
          content={
            <MyLsp
              setmastertransporterlist={setmastertransporterlist}
              planningbutton={planningbutton}
            />
          }
          title="Add Recommended Transporters"
          id="closebutton"
          screenName="LoRRI Spot"
          moduleName="My Enquiries"
          activityName="Add Transporter Button clicked"
          backdrop={false}
          size="md"
          style={{
            cursor: isRestricted ? "not-allowed" : "pointer",
            opacity: isRestricted ? 0.6 : 1,
          }}
        />

        <div className={toolbarStyles.selectGroup}>
        <div style={{ width: "115px" }} className={toolbarStyles.selectWrapper}>
            <Select
              className="basic-single"
              classNamePrefix="select"
              defaultValue={spotFilterOptions[1]}
              name="days"
              options={spotFilterOptions}
              isValidNewOption={() => false}
              isSearchable={false}
              value={spotFilterOptions.find((obj) => obj.value === interval_days)}
              onChange={(e) => handleOutsideFilterChange("days", e.value)}
              menuPortalTarget={document.body}
              styles={desktopSelectStyles}
            />
          </div>

          <div style={{ width: "175px" }} className={toolbarStyles.selectWrapper}>
            <Select
              className="basic-single"
              classNamePrefix="select"
              isValidNewOption={() => false}
              isSearchable={false}
              name="bucket"
              options={bucketOptions}
              value={{
                value: enquiryBucket,
                label:
                  enquiryBucket === "active"
                    ? "Active Enquiry"
                    : enquiryBucket === "cancelled"
                      ? "Cancelled Enquiry"
                      : enquiryBucket === "expired" || enquiryBucket === "archived"
                        ? "Archived Enquiry"
                        : enquiryBucket === "approved"
                          ? "Approved Enquiry"
                          : enquiryBucket === "pending_approval"
                            ? "Expired Pending Approval"
                            : enquiryBucket === "pending_acceptance"
                              ? "Expired Pending Acceptance"
                              : "All Enquiry",
              }}
              onChange={(e) => handleOutsideFilterChange("bucket", e.value)}
              menuPortalTarget={document.body}
              styles={desktopSelectStyles}
            />
          </div>

          {iscompanycheck && (
            <div style={{ width: "160px" }} className={toolbarStyles.selectWrapper}>
              <Select
                className="basic-single"
                classNamePrefix="select"
                name="view"
                options={[
                  { value: "user_view", label: "My Enquiries" },
                  { value: "company_view", label: "Company Enquiries" },
                ]}
                value={{
                  value: enquiryLevel,
                  label:
                    enquiryLevel === "user_view"
                      ? "My Enquiries"
                      : "Company Enquiries",
                }}
                onChange={(e) => {
                  handleOutsideFilterChange("view", e.value);
                  setuserview(e.value === "user_view");
                }}
                menuPortalTarget={document.body}
                styles={desktopSelectStyles}
                isValidNewOption={() => false}
                isSearchable={false}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default EnquiryToolbar;